import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MethodModel } from '../../models/method.model';
import { UserModel } from '../../models/user.model';

@Injectable({
    providedIn: 'root',
})
export class MeService {
    private readonly url = environment.apiUrl + '/me';

    constructor(private readonly http: HttpClient) {
    }

    me(): Observable<UserModel> {
        return this.http.get<UserModel>(`${this.url}`);
    }

    getMyMethods(): Observable<MethodModel[]> {
        return this.http.get<MethodModel[]>(`${this.url}/methods`);
    }

    setCurrentMethod(method: MethodModel): Observable<MethodModel> {
        return this.http.put<MethodModel>(`${this.url}/method`, method);
    }
}
